import type { FaireProductEntity } from "../../entity_types/product";

export const p_2zt5mz3e45: FaireProductEntity = {
  token: "p_2zt5mz3e45",
  type: "product",
  name: "Meadow Long Sleeve Slit Maxi Dress - Coco",
  brandToken: "b_41hrqq6ws3",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/7f49fee7422e3edd63d7757e1dec2b6c5f314e28a8971edb3b489a3d535b2dc0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b200517dc1f6f782e7cb421d1c96184b7ebc1db5b302090de1fef4bcfe5ad247.jpeg",
    "https://cdn.faire.com/fastly/46aba29646b875cb438ac325ba704da965ee3a89b60a6f0bde8fda6e94d08164.jpeg",
    "https://cdn.faire.com/fastly/f97c39a14ead5579d825df57510f75015fba07b3fb7937cbc5e4cb764901983d.jpeg",
    "https://cdn.faire.com/fastly/a9f0dac3e2a0c7a00af90ffed389439e9fd38712d823bbec4b4fc632f6fe9eed.jpeg",
    "https://cdn.faire.com/fastly/276aafca89d79d5b7c881da59240c744e20185a44819abfac01f748c65a3b636.jpeg",
  ],
  priceDollars: 37.42,
  description:
    'You\'re going to love wearing the Meadow Long Sleeve Slit Maxi Dress - the perfect slouchy silhouette for a cozy, yet so cute boho look!\n\nThis will become one of your go-to pieces because it features:\n\nComfortable, soft, lightweight, knit fabric\nRelaxed and loose silhouette\nMaxi length\nFlattering v-neckline with so cute exaggerate trim\nLoose long sleeves\nFront patch pockets\nExposed seams for added style throughout\nExaggerated rounded bottom edge creating side slits\n\n*Due to lighting and differences in monitors, actual colors may vary slightly from what appears online.\n\nModel is 5\'8" and wearing a size Small.\n\nApproximate measurements are as follows:\nSMALL: Bust: 46", Hip:46", Length: 49", Sleeve length: 15"\nMEDIUM: Bust: 50",Hip: 50", Length:50 ", Sleeve length:15 "\nLARGE: Bust: 54", Hip: 54", Length: 51", Sleeve length: 15"\nXLARGE: Bust: 52", Hip: 52", Length: 52", Sleeve Length: 15"\n\n96% Polyester, 4% Spandex\nHand wash cold, Lay flat to dry\nMade in Mexico',
  tags: [],
  msrpDollars: 74.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:16.889Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
